module.exports = __webpack_public_path__ + "static/media/YF83_2.6920f978.jpg";